import { 
  getTaskList,
  getTaskDetail,
  createTask, 
  batchExecute, 
  institutionList,
  uploadEncryptedFile,
  excelResult,
  excelCommit,
  budgetOrgTableList, 
  districtInstitutionList,
  taskCheck,
} from '../services/index';

export default {
  namespace: 'batchExecute',
  state: {},
  effects: {
    * getTaskList ({ payload }, { call }) {
      return yield call(getTaskList, payload);
    },
    * getTaskDetail ({ payload }, { call }) {
      return yield call(getTaskDetail, payload);
    },
    * createTask ({ payload }, { call }) {
      return yield call(createTask, payload);
    },
    * batchExecute ({ payload }, { call }) {
      return yield call(batchExecute, payload);
    },
    * getInstitutionList ({ payload }, { call }) {
      return yield call(institutionList, payload);
    },
    /**
     * 文件流加密上传
     */
    * uploadEncryptedFile ({ payload }, { call }) {
      return yield call(uploadEncryptedFile, payload);
    },

    /**
     * 获取excel导入结果（需要轮询获取）
     */
    * getExcelResult ({ payload }, { call }) {
      return yield call(excelResult, payload);
    },
    /**
     * 获取excel导入结果（需要轮询获取）
     */
    * excelCommit ({ payload }, { call }) {
      return yield call(excelCommit, payload);
    },
    
    /**
     * 区划单位表格数据
     */
    * getDistrictInstitutionList ({ payload }, { call }) {
      return yield call(districtInstitutionList, payload);
    },

    /**
     * 预算一体化单位表格数据
     */
    * getBudgetOrgTableList ({ payload }, { call }) {
      return yield call(budgetOrgTableList, payload);
    },

    /**
     * 预算一体化单位表格数据
     */
    * taskCheck ({ payload }, { call }) {
      return yield call(taskCheck, payload);
    },

  },
  reducers: {
    update ( state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
